import React, { Component, PropTypes } from 'react';
import { Grid } from 'react-bootstrap';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import BodyClassName from 'react-body-classname';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import { Loader } from '../components/loader';
import { logoutAndRedirect } from '../actions/auth';
import { isIE } from '../utils/helpers';

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isLoggedIn,
  isAdmin: state.auth.isAdmin,
  isFederation: state.auth.isFederation,
});

class App extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isFederation: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.browser = isIE() ? 'ie' : '';
  }

  onLogoutClick = e => {
    e.preventDefault();

    const { dispatch } = this.props;

    dispatch(logoutAndRedirect());
  };

  render() {
    const { children, isLoggedIn, isAdmin, isFederation } = this.props;

    let indexUrl;

    if (isAdmin) {
      indexUrl = '/admin';
    } else if (isFederation) {
      indexUrl = '/federation';
    } else {
      indexUrl = '/';
    }

    return (
      <BodyClassName className={this.browser}>
        <div className="wrapper">
          <ReduxToastr />

          <Grid>
            <Header
              indexUrl={indexUrl}
              isLoggedIn={isLoggedIn}
              isAdmin={isAdmin}
              isFederation={isFederation}
              onLogoutClick={this.onLogoutClick}
            />

            <div className="main">{children}</div>
          </Grid>

          <Footer indexUrl={indexUrl} />

          <Loader />
        </div>
      </BodyClassName>
    );
  }
}

export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/containers/App.js